export const mapSliceErrorToV5 = (error: Error) => ({
  response: {
    ...error,
  },
});
